module.exports = __webpack_public_path__ + "img/logo.2a42fe92.png";